import { useDispatch } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { user_logout, logout_session } from "../redux/actions/action";
import { isTokenExpired } from "../utils/helpers/authSession";
import { handleGeneralNotification } from "../utils/helpers/notifications";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const userId = window.localStorage.getItem("userid");
  const paymentExpired = window.localStorage.getItem("paymentExpired");

  const currentHostname = window.location.hostname;
  const isLocalhost =
    currentHostname === "localhost" ||
    currentHostname === "127.0.0.1" ||
    currentHostname === "[::1]";

  const companyDomain = window.localStorage.getItem("companyDomain");
  let companyHost = null;

  if (companyDomain) {
    try {
      companyHost = new URL(companyDomain).hostname;
    } catch (e) {
      companyHost = null;
    }
  }

  const token = window.localStorage.getItem("token");
  const keepMeLoggedIn =
    window.localStorage.getItem("keepMeLoggedIn") === "true";
  const authSessionActive =
    window.sessionStorage.getItem("authSessionActive") === "true";

  if (!userId || !token) {
    return <Redirect to="/" push={false} />;
  }

  if (!keepMeLoggedIn && !authSessionActive) {
    window.localStorage.clear();
    window.sessionStorage.removeItem("authSessionActive");
    return <Redirect to="/" push={false} />;
  }

  if (isTokenExpired()) {
    handleGeneralNotification(
      {
        notificationType: "CUSTOM",
        text: "Your session has expired. Please log in again to continue.",
      },
      false,
    );
    dispatch(logout_session({ userid: userId }));
    window.localStorage.clear();
    window.sessionStorage.removeItem("authSessionActive");
    window.localStorage.setItem(
      "sessionExpiredMessage",
      "Session expired. Please log in again.",
    );
    setTimeout(() => {
      window.location.replace("/");
    }, 1500);
    return null;
  }

  if (!isLocalhost && currentHostname !== companyHost) {
    dispatch(user_logout(userId));
    window.localStorage.clear();
    window.localStorage.clear();
    return (
      <Route
        {...rest}
        render={(props) => (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
        )}
      />
    );
  }

  if (paymentExpired && rest.path !== "/expired") {
    return <Route {...rest} render={() => <Redirect to="/expired" />} />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        userId != null ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
